module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/i18n-154.vue");


//////////////////
// WEBPACK FOOTER
// ./en/development/i18n.md
// module id = 569
// module chunks = 435